import './listPage.scss';

import * as React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { setSuccess } from '../../../actions/loadingActions';
import { DailyFormsModel } from '../../../model/DailyFormModel';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';
import { PlantModel } from '../../../model/PlantModel';
import { UserModel } from '../../../model/UserModel';
import { Async } from '../Async';
import { ErrorPage } from '../ErrorPage';
import { Loader } from '../Loader';
import { JSXElement } from 'babel-types';
import { withRouter } from 'react-router';
import { IHistory } from '../../../interfaces';

type ModelInstances = DailyFormsModel | MonthlyFormModel | PlantModel | UserModel;

export interface IListPageProps {
    identifier?: string;
    instances: ModelInstances[];
    listItemComponent: React.ComponentClass<{
        instance: ModelInstances, index: number,
        listItemProp?: string, onClick?: Function,
        className?: string;
    }>;
    renderPages?: JSX.Element;
    searchBy: string[];
    sort?: {
        heading?: string;
        sortBy?: string;
    }[];
    history?: IHistory;
    pageHeadings: string[];
    promise?: (...args: any[]) => any;
    cols: number[];
    searchPlaceHolder?: string;
    instanceOf?: string;
    emptyListMessage?: string;
    style?: React.CSSProperties;
    chartComponents?: JSX.Element;
    height?: string;
    chartTitle?: string;
    chartFilter?: JSX.Element | JSX.Element[];
    filterBy?: string;
    listItemProp?: string;
    onFilter?: Function;
    listFooter?: React.ComponentClass<{ instances: ModelInstances[], index: number, onClose: Function, id: string }>;
}

export interface IListPageState {
    searchInput: string;
    id: string;
    index?: number;
    showFooter: boolean;
    instance: any;
    filteredInstances: ModelInstances[];
    showFooterModal: boolean;
    isScrolled: boolean;
    isAscending: boolean;
}

export class ListPageImpl extends React.PureComponent<IListPageProps, IListPageState> {
    constructor(props: IListPageProps) {
        super(props);
        this.state = {
            id: '', isScrolled: false,
            searchInput: '', filteredInstances: [], showFooter: false, showFooterModal: false,
            isAscending: false, instance: null
        };
    }

    handleScroll = (e) => {
        this.setState({
            isScrolled: true
        });
    }

    renderSearchBar = () => {
        return <div>
            <input
                type="text"
                onChange={e => this.setState({ searchInput: e.target.value })}
            />
        </div>;
    }

    handleBottomSlider = (index: number, id, instance) => {
        const currentPlantInstance = PlantModel.get(id);
        if (this.state.index === index) {
            this.setState({
                showFooter: !this.state.showFooter,
                showFooterModal: true,
                index,
                id,
                instance: currentPlantInstance
            });
            return;
        }
        this.setState({
            showFooter: true,
            showFooterModal: true,
            index,
            id,
            instance: currentPlantInstance
        });
    }

    renderListItems = () => {
        const { instances, listItemComponent,
            searchBy, emptyListMessage, listItemProp } = this.props;
        const { searchInput } = this.state;
        const ListItem = listItemComponent;
        const filteredInstances = this.state.filteredInstances;
        const searchedInstances = [];
        const EmptyList = () => <div className="empty-list" >
            {`${emptyListMessage} ${searchInput ? 'for ' + searchInput : ''}`}</div>;
        if (searchInput.length > 0) {
            instances.forEach(instance => {
                searchBy.forEach(searchText => {
                    // if (instance.props[searchText] &&
                    //     instance.props[searchText].toString().toLowerCase().
                    //         indexOf(searchInput.toLowerCase()) > -1) {
                    //     if (searchedInstances.indexOf(instance) < 0) {
                    //         searchedInstances.push(instance);
                    //         return;
                    //     }
                    // }
                    if (instance.props &&
                        (JSON.stringify(instance.props).toLowerCase())
                            .indexOf(`"${searchText.toLowerCase()}":"${searchInput.toLowerCase().replace(/ /g, '')
                                }`) > -1
                    ) {
                        if (searchedInstances.indexOf(instance) < 0) {
                            searchedInstances.push(instance);
                            return;
                        }
                    }
                }
                );
            });
        }
        if (searchedInstances.length > 0 || searchInput.length > 0) {
            return <div> {searchedInstances.length > 0 ? searchedInstances.map((instance, index) => {
                return <div key={index} onClick={() => this.handleBottomSlider(index, instance.props.id, instance)}>
                    <ListItem
                        className="form-list-item"
                        index={index + 1}
                        listItemProp={listItemProp}
                        instance={instance}
                    />
                </div>;
            }) : <EmptyList />}</div>;
        }
        if (filteredInstances.length > 0 || searchInput.length > 0) {
            return <div> {filteredInstances.length > 0 ? filteredInstances.map((instance, index) => {
                return <div key={index} onClick={() => this.handleBottomSlider(index, instance.props.id, instance)}>
                    <ListItem
                        className="form-list-item"
                        index={index + 1}
                        listItemProp={listItemProp}
                        instance={instance}
                    />
                </div>;
            }) : <EmptyList />}</div>;
        }
        return <div>{instances.length > 0 ? instances.map((instance, index) => {
            return <div key={index} onClick={() => this.handleBottomSlider(index, instance.props.id, instance)}>
                <ListItem
                    className="form-list-item"
                    index={index + 1}
                    listItemProp={listItemProp}
                    instance={instance}
                />
            </div>;
        }) : <EmptyList />}</div>;
    }

    sortList = (sortFor: string) => {
        const { isAscending, filteredInstances } = this.state;
        let sortedListItems = [];
        if (!isAscending) {
            filteredInstances.length > 0 ?
                sortedListItems = filteredInstances.sort((i, j) => {
                    return new Date(j.props[sortFor]).getTime() - new Date(i.props[sortFor]).getTime() as any;
                })
                :
                sortedListItems = this.props.instances.sort((i, j) => {
                    return new Date(j.props[sortFor]).getTime() - new Date(i.props[sortFor]).getTime() as any;
                });
            this.setState({
                filteredInstances: sortedListItems,
                isAscending: !this.state.isAscending
            });
        } else {
            filteredInstances.length > 0 ?
                sortedListItems = filteredInstances.sort((i, j) => {
                    return new Date(i.props[sortFor]).getTime() - new Date(j.props[sortFor]).getTime() as any;
                })
                :
                sortedListItems = this.props.instances.sort((i, j) => {
                    return new Date(i.props[sortFor]).getTime() - new Date(j.props[sortFor]).getTime() as any;
                });
            this.setState({
                filteredInstances: sortedListItems,
                isAscending: !this.state.isAscending
            });
        } 
    }

    renderPageHeadings = () => {
        const { pageHeadings, cols, sort } = this.props; 
        
        return <Row
            id="listHeadings"
            className={this.state.isScrolled ? 'list-headings list-headings-scrolled' : 'list-headings'}
        >
            {pageHeadings.map((heading, index) => {
                const sortKey = (sort || [{ heading: 'Submitted Date', sortBy: 'Date' }]).find(data => data.heading === heading); 
                if (heading.toLowerCase() === '#') {
                    return <Col key={index} className="heading" xs={cols[index]} sm={cols[index]}>{heading}</Col>;
                } else {
                    return <Col
                        key={index}
                        className="heading"
                        sm={cols[index]}
                        xs={cols[index]}
                    >
                        {heading.toLowerCase().indexOf('submitted date') > -1 ?
                            [<span key={index + 50}>
                                {heading}
                                &nbsp;
                            </span>,
                            <i
                                key={index + 20}
                                onClick={() => this.sortList(sortKey.sortBy)}
                                className="fa fa-sort"
                                style={{ color: 'white' }}
                                aria-hidden="true"
                            />]
                            : heading}
                    </Col>;
                }
            })}
        </Row>;
    }

    isMobileDevice = () => {
        if (navigator.userAgent.toString().indexOf('Mobile') > -1) {
            return true;
        }
        return false;
    }

    renderFooterModal = () => {
        const ListFooter = this.props.listFooter;
        const { instances } = this.props;
        return this.props.listFooter && this.props.instances.length > 0 ? <Modal
            className="list-item-modal"
            show={this.state.showFooterModal}
            onHide={() => this.setState({ showFooterModal: false })}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title">
                    Plant Info for  PlantID: {this.state.instance ? this.state.instance.props.PlantId : ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ListFooter id={this.state.id} onClose={null} instances={instances} index={this.state.index} />
            </Modal.Body>
        </Modal> : '';

    }

    renderListPage = () => {
        const { chartTitle, chartFilter, filterBy } = this.props;

        const ListFooter = this.props.listFooter;
        return <div className="list-page" style={this.props.style} >
            {this.renderFooterModal()}
            <div style={{ fontSize: '20px', textAlign: 'center' }} className="chart-title" >
                {`${chartTitle || ''}  ${filterBy ? 'for ' + filterBy : ''}` || ''}
            </div>
            <div style={{ textAlign: 'center' }} className="chart-title" >{chartFilter || ''}</div>
            {this.props.chartComponents}
            <div className="search-container" >
                <i className="fa fa-search" aria-hidden="true"></i>
                <input
                    className="search-input"
                    type="text"
                    onChange={e => this.setState({ searchInput: e.target.value })}
                    placeholder={this.props.searchPlaceHolder}
                />
            </div>
            {this.renderPageHeadings()}
            <div onScroll={this.handleScroll} style={{ height: this.props.height || '71vh' }}>
                <PerfectScrollbar id="scrollbar" >
                    <Async
                        identifier={this.props.identifier}
                        promise={() => setSuccess(this.props.identifier)}
                        loader={<Loader type="async" />}
                        error={<ErrorPage />}
                        content={this.renderListItems()}
                    />
                </PerfectScrollbar>
            </div>

        </div>;
    }

    render() {
        return (
            <React.Fragment>
                <Async
                    identifier={'ListPageAll'}
                    promise={this.props.promise
                    }
                    loader={< Loader type="async" />}
                    error={< ErrorPage />}
                    content={this.renderListPage()}
                />
                {this.props.renderPages}
            </React.Fragment>);
    }
}

export const ListPage = withRouter(ListPageImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ListPage/index.tsx